export default "__VITE_ASSET__BLjApZlB__"